import { IPaginatedNovelOrderWithCustomerRelationship } from "@novel/shared/interfaces/Order";
import { NovelVendorSubReducer } from "@vendor-portal/redux/vendorTypedRedux";

export interface IOrdersReducerState extends IPaginatedNovelOrderWithCustomerRelationship {
    isLoading: boolean;
}

const initialState: IOrdersReducerState = {
    isLoading: true,
    totalCount: 0,
    pageSize: 0,
    pageNumber: 0,
    totalPages: 0,
    data: [],
};

export const ordersReducer: NovelVendorSubReducer<IOrdersReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOADING_ORDERS": {
            return {
                ...state,
                isLoading: true,
            };
        }

        case "ERROR_LOADING_ORDERS": {
            return {
                ...state,
                isLoading: false,
            };
        }

        case "LOADED_ORDERS": {
            return {
                ...state,
                totalCount: action.payload.paginatedOrders.totalCount,
                pageSize: action.payload.paginatedOrders.pageSize,
                pageNumber: action.payload.paginatedOrders.pageNumber,
                totalPages: action.payload.paginatedOrders.totalPages,
                data: action.payload.paginatedOrders.data,
                isLoading: false,
            };
        }

        default:
            return state;
    }
};
